import React from 'react';
import DirectClients from './direct-cients/DirectClients';
import NonDirectClients from './non-direct-clients/NonDirectClients';


const CounsellorExpanded = ({clients}) => {
    const {direct, nonDirect} = clients

    return (
        <>
            <DirectClients 
                clients={direct}    
            />
            <NonDirectClients 
                clients={nonDirect}
            />
        </>
    )
};

export default CounsellorExpanded;
